<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <TablePage :tableWidth="windowWidth" :columnsList="quotationColumnList" :resultList="quotationList"
        :tableMaxHeight="800"></TablePage>
    </Feature>
    <ButtonRow>
      <Button type="primary" @click="downalod" slot="1">{{ $t('DOWNLOAD') }}</Button>
      <Button type="info" @click="Back" slot="2">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="scalePricesModel" :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="999" :reset-drag-position="true" width="900" v-model="cpcToSupervisorAttachmentsModel" sticky
      :draggable="true" :title="$t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="pcToSupervisorAttachments"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="999" :reset-drag-position="true" width="900" v-model="supplierQuotationFilesModel" sticky
      :draggable="true" :title="$t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierQuotationFiles"></FileDocument>
      </div>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import FileDocument from '../../components/FileDocument.vue'
import { Translate, FloraEditorConfig } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import moment from "moment"

export default {
  name: "CpcDetailMaintain",
  components: {
    FileDocument,
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      routerValue: '',
      scalePricesModel: false,
      logComment: '',
      logCommentModel: false,
      quotationUuid: '',
      supplierQuotationFiles: [],
      supplierQuotationFilesModel: false,
      cpcToSupervisorAttachments: [],
      cpcToSupervisorAttachmentsModel: false,
      scalePrices: [],
      abnormals: [],
      comments: '',
      remark: '',
      defaultValidTo: '',
      flowComment: '',
      file: null,
      fileSchemaList: FileSchemaList(this),
      priceList: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      quotationList: [],
      quotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("ALERT")
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-radio-button-on",
                size: 28,
              },
              class: this.alertColorClass(params.row)
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('NEW_AND_OLD')
            return h('div', {
              domProps: {
                innerHTML: params.row.currentPrice === undefined || params.row.currentPrice === null ? "NEW" : "OLD"
              }
            });
          },
          render: (h, params) => {
            let text = params.row.currentPrice ? "OLD" : "NEW"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('HIGH_PRICE_TITLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return !params.row.highPrice ? "" : h("Icon", {
              props: {
                type: "ios-warning",
                size: 28,
              },
              class: "text-delta-red"
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            let deltaPart = params.row.deltaPart != undefined ? params.row.deltaPart : ""
            let deltaPartDesc = params.row.deltaPartDesc != undefined ? params.row.deltaPartDesc : ""
            let text = deltaPart + "<br>" + deltaPartDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "vendorPartNo",
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('RFQ_QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          key: "rfqQty",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM_CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          align: 'center',
          key: "itemCategory",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE_TITLE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 50,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TARGET') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          key: "targetPrice"
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENT') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          key: "currentPrice"
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE') + "<br>" + this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            if (params.row.abnormals && params.row.abnormals.quoteRedAlert || params.row.quoteRedAlert) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    shape: "circle",
                    size: 'small'
                  },
                  style: { width: '80%' },
                }, params.row.price),
                h("span", {}, '/' + params.row.currency)
              ]);
            } else {
              let price = params.row.price != undefined ? params.row.price : ""
              let currency = params.row.currency != undefined ? params.row.currency : ""
              let text = price + '/' + currency
              return h('div', {
                domProps: {
                  innerHTML: text
                }
              })
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = "RFQ CD%"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            let result = params.row.currentPrice ? Math.floor(((params.row.rfqQty * params.row.currentPrice - params.row.rfqQty * params.row.price) / (params.row.rfqQty * params.row.currentPrice) * 100) * 100) / 100 : "NA"
            return h('div', {
              domProps: {
                innerHTML: result
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = "Target CD%"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            let result = params.row.price ? Math.floor(((params.row.rfqQty * params.row.targetPrice - params.row.rfqQty * params.row.price) / (params.row.rfqQty * params.row.targetPrice) * 100) * 100) / 100 : "NA"
            return h('div', {
              domProps: {
                innerHTML: result
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validFrom",
          width: 100,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validTo",
          width: 100,
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTATION_FILE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["supplierQuotationFiles"] && this.quotationList[params.index].supplierQuotationFiles.filter(attachment => !attachment.deleted).length > 0 ? "md-reorder" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.supplierQuotationFiles = this.quotationList[params.index].supplierQuotationFiles ? this.quotationList[params.index].supplierQuotationFiles.filter(attachment => !attachment.deleted) : []
                  this.supplierQuotationFilesModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_FILE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["cpcToSupervisorAttachments"] && this.quotationList[params.index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted).length > 0 ? "md-reorder" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.cpcToSupervisorAttachments = this.quotationList[params.index].cpcToSupervisorAttachments ? this.quotationList[params.index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted) : []
                  this.cpcToSupervisorAttachmentsModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["scalePrices"] && params.row["scalePrices"].length > 0 ? "md-reorder" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.scalePrices = params.row.scalePrices
                  this.scalePricesModel = true
                },
              },
            })
          }
        }
      ]
    }
  },
  created() {
    this.defaultValidTo = getDefaultValidTo();
    search(this)
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth", "getStatusReportGroupId"]),
    ...mapActions(["toggleLoading"]),
    Back() {
      this.$router.push({ name: 'STATUS_REPORT' })
    },
    downalod() {
      console.log("downalod")
    },
    alertColorClass(row) {
      if (row.targetPrice !== row.price) {
        return "text-delta-yellow";
      }
      if (row.currentPrice === undefined || row.currentPrice === null || row.price === row.currentPrice) {
        return "text-delta-blue";
      }
      if (row.price > row.currentPrice) {
        return "text-delta-red";
      }
      return "text-delta-green";
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function getDefaultValidTo() {
  let today = new Date();
  if ((today.getMonth() + 1) > 9) {
    return moment([today.getFullYear() + 1, 11, 31]).format("YYYY-MM-DD")
  } else {
    return moment([today.getFullYear(), 11, 31]).format("YYYY-MM-DD")
  }
}

function search(vueInstance) {
  vueInstance.selectAllType = ""
  let url = ""
  vueInstance.routerValue = vueInstance.getStatusReportGroupId()
  url = "/status-report/details/group/" + vueInstance.getStatusReportGroupId()
  getSearch(vueInstance, url)
}

function getSearch(vueInstance, url) {
  if (url == "" || vueInstance.routerValue == "") {
    // vueInstance.Back()
  } else {
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .get(url)
      .then((response) => {
        vueInstance.toggleLoading(false)
        if (response.data) {
          vueInstance.quotationList = response.data._embedded.statusReportQuotationDetailResourceList
          vueInstance.supplierQuotationFiles = vueInstance.quotationList[0].supplierQuotationFiles
          vueInstance.cpcToSupervisorAttachments = vueInstance.quotationList[0].cpcToSupervisorAttachments
        } else {
          vueInstance.$Notice.success({
            title: Translate("COMMON_MESSAGE_INFO"),
            desc: Translate("COMMON_MESSAGE_INFO"),
            render: h => {
              return h('span', [
                Translate("COMMON_TEXT_NOTHING")
              ])
            }
          });
          vueInstance.Back()
        }
      })
      .catch(() => {
        // vueInstance.Back()
        vueInstance.toggleLoading(false)
      })
  }
}
</script>
  
<style scoped>
/* table {
    width: 200% !important;
  } */
</style>
  